import { css } from 'styled-components';

/* The shared component renders the price row and the saving as two siblings. The
   PDP drops that into a flex row it shares with the rating pill, so the block
   needs a root of its own to stay one item and keep the saving under the price. */
export const root = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
